import { styled, Popper } from '@mui/material';
import { GridRow } from '@mui/x-data-grid-pro';

export type GridColumn = {
  header: string;
  field: string;
};

export const gridSx = {
  fontSize: '14px',
  border: '1px solid #E5E6E7',
  '& .MuiDataGrid-columnHeaderTitle': { fontWeight: 'normal' },
  '& .MuiSvgIcon-fontSizeMedium': { fontSize: '20px' },
  '& .MuiSvgIcon-fontSizeSmall': { fontSize: '18px', color: '#212121' },
  '& .MuiDataGrid-columnHeader': { paddingLeft: '16px' },
  '& .MuiDataGrid-cell': { padding: '0 16px' },
  '& .MuiDataGrid-columnHeader:focus-within, .MuiDataGrid-cell:focus-within': { outline: 'none' },
  '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': { display: 'none' },
  '& .MuiDataGrid-columnSeparator, .MuiDataGrid-columnSeparator--sideRight': { color: '#c1c1c1' },
  '& .MuiDataGrid-container--top': { borderBottom: '1px solid #AAAEB0'},
  '& .MuiDataGrid-row': { borderTop: '1px solid #E5E6E7' },
};

export const paginationSx = {
  "& .MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows": { fontSize: '14px' },
  "& .MuiInputBase-root": { fontSize: '14px', top: '-3px' },
  "& .MuiTablePagination-selectIcon": { right: '-20px', top: '5px' },
  "& .MuiTablePagination-actions > button": { top: '-5px' },
};

export const features = {
  disableColumnSelector: true,
  disableColumnPinning: true,
  disableColumnReorder: true,
  disableRowSelectionOnClick: true,
  disableMultipleRowSelection: true,
  disableVirtualization: true,
  disableColumnResize: true,
}

export const StripedGridRow = styled(GridRow)(({ theme }) => ({
  '&:nth-of-type(odd), &:nth-of-type(odd):hover': {
    backgroundColor: "#f6f7f8",
  },
  '&:nth-of-type(even), &:nth-of-type(even):hover': {
    backgroundColor: "#ffffff",
  }
}));

export const OptionsPopper = styled(Popper)(({ theme }) => ({
  '& .MuiSvgIcon-fontSizeSmall': {
    fontSize: "18px",
  },
  '& .MuiPaper-root': {
    boxShadow: "0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12)"
  }
}));